import ReceiveItemsListPanel from "./receiveItemsListPanel.container";
export default ReceiveItemsListPanel;
